import React from "react";

import GoogleMapSection from "../components/GoogleMapSection";
import ContactInfoSection from "../components/ContactInfoSection";
import ContactFormSection from "../components/ContactFormSection";
import WithUsSection from "../components/WithUs";
import { Link } from "react-router-dom";

const ContactPage = () => {
  const withUsData = {
    subtitle: "Get in Touch with Us",
    heading: "We’d Love to Hear From You!",
    intro: `Jaswinder (Jaz) Sidhu is C.Tech, Commercial Building Inspector, National Certificate Holder, Registered Home Inspector, Mold Inspector, Certified Septic Inspector, Environmental Assessor, and well-experienced with over 18 years.`,
    introtwo: 'He was on the Board of Directors of the Ontario Association of Home Inspectors (OAHI) for two years.',
    registrationTitle: "Professional Registrations:",
    membershipTitle: "He is a proud member of:",
    memberships: [
      "Ontario Association of Home Inspectors",
      "Canadian Association of Home and Property Inspectors",
      "International Association of Certified Home Inspectors",
      "Ontario Association of Certified Engineering Technicians and Technologists",
    ],
    additionalParagraphs: [
      "When it comes to inspections in Canada, our company, Technominds Inspections is a leading firm.",
      "Our reliable and unbiased professionals are experienced in inspecting Residential and Commercial Buildings and Mold Inspections, for more than 18 years.",
      "If you are looking for pre-purchase or post-purchase property inspection services in Ontario, call us NOW.",
      "Call Us at  416-500-1535",
    ],
  };

  return (
    <>
      <div class="contact-page-wrapper page-id-007 common-001">
        <section className="section-banner">
          <div className="container">
            <div className="inner-content">
              <p>Fast, Reliable Home Inspections for Agents & Homeowners</p>
              <h1>
                Contact<span> Us</span>
              </h1>
              <p>
                Discover peace of mind with our expert home inspection services,
                designed to meet the needs of both real estate agents and
                property owners. Our team ensures thorough evaluations and
                prompt reporting, helping you make informed decisions.
              </p>
              <div className="dft-btn">
                <Link to="/industerial-building" className="btn">
                  For Inspection Services
                </Link>
              </div>
            </div>
          </div>
        </section>

        <WithUsSection withUsData={withUsData} />
        <ContactInfoSection />

        <ContactFormSection />
      </div>
    </>
  );
};

export default ContactPage;
